import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from '@supply-mover-2-0/web-ui';
import { useNavigate } from 'react-router-dom';

/**
 * Desktop breadcrumb back to the account home (PD-14080 review feedback):
 * "Account › <Page>" right before the page title. Mobile keeps the
 * MobilePageHeader back arrow, so this renders md+ only.
 */
export function AccountBreadcrumb({
	current,
}: {
	current: string;
}): JSX.Element {
	const { t } = useTranslation();
	const navigate = useNavigate();

	return (
		<nav className="hidden md:flex items-center gap-1.5 text-xs text-brand-muted mb-1">
			<button
				type="button"
				onClick={() => {
					void navigate('/account');
				}}
				className="hover:text-portal-accent hover:underline"
			>
				{t('Account')}
			</button>
			<FontAwesomeIcon icon={faChevronRight} className="text-[10px]" />
			<span>{t(current)}</span>
		</nav>
	);
}
